<template>
  <div>
    <div class="up_wrap" :class="{ v2_test_wrap: isEasyInfoTest }">
      <div class="up_box" @click="handleUpgradeClick">
        <div class="info">
          <h5 class="hyphenate-text">{{ upgradeText }}</h5>
          <p
            class="hyphenate-text"
            v-html="$t('FoodC_membership_SyjM_DiMe', { percent: upgradeSavePercent })"
          ></p>
        </div>
      </div>
    </div>
    <upgrade-long-term-popup
      v-show="showUpgradePopup"
      v-model="showUpgradePopup"
      :upgradeLongTerm="upgradeLongTerm"
      @closeUpgradePopup="handleCloseUpgradePopup"
      @onUpgradeSuccess="handleSuccessUpgradeDialog"
      @onUpgradeFail="handleFailUpgradeDialog"
    ></upgrade-long-term-popup>
    <member-fail-dialog
      v-model="isShowPayFailedDialog"
      :rules="payFailedReason"
      :title="$t('FoodC_register_cCpr_KUUG')"
      @closeDialog="closePayFailedDialog"
    />
  </div>
</template>

<script>
import mixin from '@/page/member/mixins.js'
import UpgradeLongTermPopup from '@/page/member/components-v2/upgrade-long-term-popup.vue'
import MemberFailDialog from '@/page/member/components-v2/member-fail-dialog.vue'
import { CYCLE_TYPE, MODULE_TYPE } from '@/page/member/common/enumsUtil.js'

export default {
  components: {
    UpgradeLongTermPopup,
    MemberFailDialog,
  },
  mixins: [mixin],
  props: {
    membership: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showUpgradePopup: false,
      isShowPayFailedDialog: false,
      payFailedReason: [
        {
          content: [this.$t('FoodC_register_qELy_skhp')],
        },
      ],
    }
  },
  computed: {
    upgradeText() {
      let text = ''
      switch (this.upgradeLongTerm?.cycleType) {
        case CYCLE_TYPE.quarter:
          text = this.$t('FoodC_membership_Kgjx_NwXL')
          break
        case CYCLE_TYPE.halfYear:
          text = this.$t('FoodC_membership_Cmcr_KOyO')
          break
        case CYCLE_TYPE.year:
          text = this.$t('FoodC_membership_dfUx_OawR')
          break
      }
      return text
    },
    upgradeSavePercent() {
      const savePercent = this.upgradeLongTerm?.savePercent
      return `<span>${savePercent}%</span>`
    },
  },
  methods: {
    handleUpgradeClick() {
      this.showUpgradePopup = true
      this.membershipLandingCkFn(MODULE_TYPE.TERM_LONG)
    },
    handleCloseUpgradePopup() {
      this.showUpgradePopup = false
    },
    handleSuccessUpgradeDialog(data) {
      this.$emit('onUpgradeSuccess', data)
    },
    handleFailUpgradeDialog() {
      this.isShowPayFailedDialog = true
    },
    closePayFailedDialog() {
      this.isShowPayFailedDialog = false
      this.showUpgradePopup = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.up_wrap {
  margin: 20px;
  // 适配实验样式 start
  &.v2_test_wrap {
    margin: 20px 32px;
    .up_box {
      background-size: 686px 228px;
      .info {
        width: 468px;
      }
    }
  }
  // 适配实验样式 end
}
.up_box {
  border-radius: 40px;
  width: 100%;
  background-color: #fff;
  background-image: url('../imgs/up_bg.jpg');
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 710px 228px;
  .info {
    padding: 32px;
    padding-right: 0;
    width: 480px;
    h5 {
      padding-bottom: 4px;
      font-family: DiDiSans-Pro-ExtraBold;
      font-size: 28px;
      color: #0b0b0d;
      line-height: 40px;
      @include ellipsis(2);
    }
    p {
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #0b0b0d;
      line-height: 40px;
      @include ellipsis(2);
      ::v-deep span {
        font-family: DiDiSans-Pro-ExtraBold;
        color: #ff5f14;
      }
    }
  }
}
</style>
